var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fpaDetail" },
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _vm.canUpdate ||
      _vm.isAttachmentUpload ||
      _vm.formData.canAudit ||
      _vm.ssApprove ||
      _vm.hgsApprove ||
      _vm.isSignUpload ||
      _vm.canSupplierSign ||
      _vm.ssReApprove ||
      _vm.formData.canReturn ||
      _vm.canSsDirectorApprove ||
      _vm.canSnrDirectorApprove ||
      _vm.canFdApprove ||
      _vm.canScmVpApprove ||
      _vm.canCfoVpApprove ||
      _vm.canCeoApprove ||
      _vm.lmApprove ||
      _vm.lmReApprove ||
      _vm.canHlmApprove
        ? _c(
            "el-row",
            {
              staticClass: "btn",
              attrs: { type: "flex", justify: "start", align: "middle" },
            },
            [
              _vm.canUpdate
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.fpaSave } },
                    [_vm._v("Save As Draft")]
                  )
                : _vm._e(),
              _vm.canUpdate
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.isSubmitLoading,
                        disabled: _vm.isSubmitDisabled,
                        type: "primary",
                      },
                      on: { click: _vm.fpaSubmit },
                    },
                    [_vm._v("Submit")]
                  )
                : _vm._e(),
              _vm.isAttachmentUpload
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.attachmentUpload("1")
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("fpaManage.permanent.attachmentUpload"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.formData.canAudit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.formData.canAudit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.ssApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.ssApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.lmApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.lmApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.lmReApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.lmReApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.lmReApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.returnToSu },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("fpaManage.permanent.returnToSupplier"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.hgsApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.hgsApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.isSignUpload
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.attachmentUpload("0")
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("fpaManage.permanent.signatureUpload"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.canSupplierSign
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.suSignSubmit },
                    },
                    [_vm._v("Submit")]
                  )
                : _vm._e(),
              _vm.ssReApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.ssReApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.ssReApprove || _vm.formData.canReturn
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.returnToSu },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("fpaManage.permanent.returnToSupplier"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.canSsDirectorApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canSsDirectorApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canSnrDirectorApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canSnrDirectorApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canFdApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canFdApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canScmVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canScmVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canCfoVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canCfoVpApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canCeoApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canCeoApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
              _vm.canHlmApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("approving")
                        },
                      },
                    },
                    [_vm._v("Approve")]
                  )
                : _vm._e(),
              _vm.canHlmApprove
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaApprove("reject")
                        },
                      },
                    },
                    [_vm._v("Reject")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "formData1",
          attrs: {
            model: _vm.formData,
            "label-width": "230px",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "view_content" }, [
            _c("div", { staticClass: "fpaNo" }, [
              _c("p", [_vm._v("FPA NO:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.fpaNo))]),
            ]),
            _c("div", { staticClass: "status" }, [
              _c("p", [_vm._v("Status:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.queryStatus))]),
            ]),
            _c("div", { staticClass: "creator" }, [
              _c("p", [_vm._v("Creator:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.createUser))]),
            ]),
            _c("div", { staticClass: "createDate" }, [
              _c("p", [_vm._v("Creation Date:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.createDate))]),
            ]),
            _c("div", { staticClass: "approver" }, [
              _c("p", [_vm._v("Last Approver:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.lastApprover))]),
            ]),
          ]),
          _c("div", { staticClass: "info_box" }, [
            _c(
              "div",
              { staticClass: "info_box_lf" },
              [
                _c("div", { staticClass: "info_box_title" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "info_title" }, [
                    _vm._v("Basic Information"),
                  ]),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { prop: "purposeOfTheAgreement" },
                          },
                          [
                            _c(
                              "p",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c("span", {
                                  staticClass: "icon-fenlei element_icon",
                                }),
                                _vm._v(" Purpose of the Agreement "),
                              ]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { disabled: !_vm.canUpdate },
                                model: {
                                  value: _vm.formData.agreementPurpose,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "agreementPurpose",
                                      $$v
                                    )
                                  },
                                  expression: "formData.agreementPurpose",
                                },
                              },
                              _vm._l(
                                _vm.agreementPurposeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm._f("inputChoiceI18n")(item),
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 13 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              prop: "category1",
                              rules: _vm.fpaRules1.category1,
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "required_p",
                                attrs: { slot: "label" },
                                slot: "label",
                              },
                              [
                                _c("span", {
                                  staticClass: "icon-leimu2 element_icon",
                                }),
                                _vm._v(" Category1 "),
                              ]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  disabled: _vm.ttFpaId > 0,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeCategory1()
                                  },
                                },
                                model: {
                                  value: _vm.formData.category1,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "category1", $$v)
                                  },
                                  expression: "formData.category1",
                                },
                              },
                              _vm._l(_vm.category1List, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              prop: "category2",
                              label: "Category2",
                              rules: _vm.fpaRules1.category2,
                              "label-width": "140px",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  disabled: _vm.ttFpaId > 0,
                                },
                                on: { change: _vm.changeCategory2 },
                                model: {
                                  value: _vm.formData.category2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "category2", $$v)
                                  },
                                  expression: "formData.category2",
                                },
                              },
                              _vm._l(_vm.category2List, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              prop: "supplierName",
                              rules: _vm.fpaRules1.supplierName,
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "required_p",
                                attrs: { slot: "label" },
                                slot: "label",
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "icon-yonghutianchong element_icon",
                                }),
                                _vm._v(" Supplier "),
                              ]
                            ),
                            _vm.canUpdate
                              ? _c(
                                  "el-input",
                                  {
                                    staticClass: "handle-input",
                                    attrs: { title: _vm.formData.supplierName },
                                    model: {
                                      value: _vm.formData.supplierName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "supplierName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.supplierName",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "input-search",
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-search",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.supplierChoose.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                      slot: "append",
                                    }),
                                  ],
                                  1
                                )
                              : _c("el-input", {
                                  staticClass: "handle-input",
                                  attrs: {
                                    disabled: "",
                                    title: _vm.formData.supplierName,
                                  },
                                  model: {
                                    value: _vm.formData.supplierName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "supplierName",
                                        $$v
                                      )
                                    },
                                    expression: "formData.supplierName",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              prop: "productOrCommodityPurchased",
                              rules: _vm.fpaRules1.productOrCommodityPurchased,
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "required_p",
                                attrs: { slot: "label" },
                                slot: "label",
                              },
                              [
                                _c("span", {
                                  staticClass: "icon-miaoshu element_icon",
                                }),
                                _vm._v(" Product or Commodity Purchased "),
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                disabled: !_vm.canUpdate,
                                title: _vm.formData.productOrCommodityPurchased,
                              },
                              model: {
                                value: _vm.formData.productOrCommodityPurchased,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "productOrCommodityPurchased",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.productOrCommodityPurchased",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 13 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              prop: "agreementStartDate",
                              rules: _vm.fpaRules1.agreementStartDate,
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "required_p",
                                attrs: { slot: "label" },
                                slot: "label",
                              },
                              [
                                _c("span", {
                                  staticClass: "icon-riqi element_icon",
                                  staticStyle: {
                                    "font-size": "24px!important",
                                  },
                                }),
                                _vm._v(" Agreement Start Date "),
                              ]
                            ),
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: !_vm.canUpdate,
                                type: "date",
                                placeholder: "选择日期",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": _vm.pickerOptionsStart,
                              },
                              model: {
                                value: _vm.formData.agreementStartDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "agreementStartDate",
                                    $$v
                                  )
                                },
                                expression: "formData.agreementStartDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              prop: "agreementEndDate",
                              rules: _vm.fpaRules1.agreementEndDate,
                              label: "Agreement End Date",
                              "label-width": "140px",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: !_vm.canUpdate,
                                type: "date",
                                placeholder: "选择日期",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": _vm.pickerOptionsEnd,
                              },
                              model: {
                                value: _vm.formData.agreementEndDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "agreementEndDate",
                                    $$v
                                  )
                                },
                                expression: "formData.agreementEndDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              prop: "purchaseFrequency",
                              rules: _vm.fpaRules1.purchaseFrequency,
                            },
                          },
                          [
                            _c(
                              "p",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c("span", {
                                  staticClass: "icon-pinshuai1 element_icon",
                                }),
                                _vm._v(" Purchase Frequency "),
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                disabled: !_vm.canUpdate,
                                title: _vm.formData.purchaseFrequency,
                              },
                              model: {
                                value: _vm.formData.purchaseFrequency,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "purchaseFrequency",
                                    $$v
                                  )
                                },
                                expression: "formData.purchaseFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.formData.category2 == "Toys"
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 13 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  prop: "currency",
                                  rules: _vm.fpaRules1.currency,
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", {
                                      staticClass: "icon-qianbi element_icon",
                                    }),
                                    _vm._v(" Currency "),
                                  ]
                                ),
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    table: "BASE",
                                    field: "CURRENCY_CODE",
                                    disabled: !_vm.canUpdate,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeToysCurrency()
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.currency,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "currency", $$v)
                                    },
                                    expression: "formData.currency",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "info_box_rg" }, [
              _vm.formData.category2 == "package-service" ||
              _vm.formData.category2 == "toy-service" ||
              _vm.formData.category2 == "planning-service" ||
              _vm.formData.category2 == "Toys"
                ? _c("div", [
                    _c("div", { staticClass: "info_box_title" }, [
                      _c("p", { staticClass: "line" }),
                      _c("p", { staticClass: "info_title" }, [
                        _vm._v(" Notional Value of Agreement "),
                        _vm.formData.category2 != "Toys"
                          ? _c("span", [
                              _vm._v("(total amount in RMB with VAT)"),
                            ])
                          : _vm._e(),
                        _vm.formData.category2 == "Toys"
                          ? _c("span", [_vm._v("(total amount with VAT)")])
                          : _vm._e(),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "price_box2" },
                      [
                        _c("span", { staticClass: "icon-huobi qian" }),
                        (_vm.formData.category2 != "package-service" &&
                          _vm.formData.category2 != "toy-service" &&
                          _vm.formData.category2 != "planning-service") ||
                        !_vm.canUpdate
                          ? _c("p", { staticClass: "notional_qian" }, [
                              _vm._v(
                                _vm._s(_vm.formData.notionalValueOfAgreement)
                              ),
                            ])
                          : _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  width: "80%",
                                  "margin-bottom": "0",
                                },
                                attrs: {
                                  prop: "notionalValueOfAgreement",
                                  rules: _vm.fpaRules1.notionalValueOfAgreement,
                                  "label-width": "0",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    oninput:
                                      "value=value.replace(/[^0-9]/g,'')",
                                    title:
                                      _vm.formData.notionalValueOfAgreement,
                                  },
                                  model: {
                                    value:
                                      _vm.formData.notionalValueOfAgreement,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "notionalValueOfAgreement",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.notionalValueOfAgreement",
                                  },
                                }),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ])
                : _c("div", [
                    _c("div", { staticClass: "info_box_title" }, [
                      _c("p", { staticClass: "line" }),
                      _c("p", { staticClass: "info_title" }, [
                        _vm._v(
                          "Notional Value of Agreement (total amount in RMB with VAT)"
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "price_box2" }, [
                      _c("span", { staticClass: "icon-huobi qian" }),
                      _c("p", { staticClass: "notional_qian" }, [
                        _vm._v(_vm._s(_vm.formData.notionalValueOfAgreement)),
                      ]),
                    ]),
                  ]),
              _c(
                "div",
                {
                  staticClass: "info_box_title",
                  staticStyle: { "margin-top": "10px" },
                },
                [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "info_title" }, [_vm._v("Coverage")]),
                ]
              ),
              _vm.formData.category2 != "logistic" &&
              _vm.formData.category2 != "planning-service"
                ? _c(
                    "div",
                    { staticClass: "coverage_table" },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.formData.fpaSupplierCoverageList,
                            border: "",
                            "max-height": "124px",
                            "highlight-current-row": "",
                          },
                          on: {
                            "selection-change":
                              _vm.handleSupplierCoverageChange,
                          },
                        },
                        [
                          _vm.canUpdate
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  type: "selection",
                                  width: "55",
                                },
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              prop: "plantName",
                              label: "Supplier Facility",
                              width: "150px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "coverage",
                              label: "Supplier Coverage",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        staticStyle: { width: "40%" },
                                        attrs: {
                                          disabled: !_vm.canUpdate,
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.coverage,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "coverage", $$v)
                                          },
                                          expression: "scope.row.coverage",
                                        },
                                      }),
                                      _vm._v(
                                        " % in terms of annual capacity utilization "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2218399579
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.category2 != "logistic" &&
              _vm.formData.category2 != "planning-service"
                ? _c(
                    "div",
                    {
                      staticClass: "total_box",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "totalForm",
                          attrs: {
                            prop: "supplierCoverageTotal",
                            "label-width": "64px",
                            "label-position": "right",
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", {
                                staticClass: "icon-heji element_icon",
                              }),
                              _c("span", [_vm._v("  Total")]),
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "40%" },
                            attrs: {
                              onkeyup:
                                "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,4})?).*$/g, '$1')",
                            },
                            model: {
                              value: _vm.formData.supplierCoverageTotal,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "supplierCoverageTotal",
                                  $$v
                                )
                              },
                              expression: "formData.supplierCoverageTotal",
                            },
                          }),
                          _c("span", [
                            _vm._v("% in terms of annual business revenue"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.category2 == "logistic" ||
              _vm.formData.category2 == "planning-service"
                ? _c(
                    "div",
                    { staticClass: "coverage_table" },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.formData.fpaDcCoverageList,
                            border: "",
                            "max-height": "124px",
                            "highlight-current-row": "",
                          },
                          on: {
                            "selection-change": _vm.handleDcCoverageChange,
                          },
                        },
                        [
                          _vm.canUpdate
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  type: "selection",
                                  width: "55",
                                },
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              prop: "dcName",
                              label: "Supplier DC",
                              width: "150px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "coverage",
                              label: "Supplier Coverage",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        staticStyle: { width: "40%" },
                                        attrs: {
                                          disabled: !_vm.canUpdate,
                                          onkeyup:
                                            "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,4})?).*$/g, '$1')",
                                        },
                                        model: {
                                          value: scope.row.coverage,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "coverage", $$v)
                                          },
                                          expression: "scope.row.coverage",
                                        },
                                      }),
                                      _vm._v(
                                        " % in terms of annual capacity utilization "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4271386195
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.category2 == "logistic" ||
              _vm.formData.category2 == "planning-service"
                ? _c(
                    "div",
                    {
                      staticClass: "total_box",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "totalForm",
                          attrs: {
                            prop: "supplierCoverageTotal",
                            "label-width": "100px",
                            "label-position": "right",
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", {
                                staticClass: "icon-heji element_icon",
                              }),
                              _c("span", [_vm._v("  Total")]),
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "40%" },
                            attrs: {
                              disabled: !_vm.canUpdate,
                              onkeyup:
                                "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,4})?).*$/g, '$1')",
                            },
                            model: {
                              value: _vm.formData.supplierCoverageTotal,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "supplierCoverageTotal",
                                  $$v
                                )
                              },
                              expression: "formData.supplierCoverageTotal",
                            },
                          }),
                          _c("span", [
                            _vm._v("% in terms of annual business revenue"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm.formData.category2 == "package-service" ||
          _vm.formData.category2 == "toy-service" ||
          _vm.formData.category2 == "planning-service" ||
          _vm.formData.category2 == "Toys"
            ? _c(
                "div",
                { staticClass: "price_info" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info_box_title",
                      staticStyle: { "padding-top": "10px" },
                    },
                    [
                      _c("p", { staticClass: "line" }),
                      _c("p", { staticClass: "info_title" }, [
                        _vm._v("Price Information"),
                      ]),
                    ]
                  ),
                  _vm.formData.category2 == "package-service" ||
                  _vm.formData.category2 == "toy-service" ||
                  _vm.formData.category2 == "planning-service" ||
                  _vm.formData.category2 == "Toys"
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 9 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    prop: "agreedPriceWithVat",
                                    rules: _vm.fpaRules1.agreedPriceWithVat,
                                    "label-width": "230px",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("Agreed Price")]
                                  ),
                                  _vm.formData.category2 != "Toys"
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: { "line-height": "1" },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _vm._v(
                                            "(price/case or tray in RMB with VAT)"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.formData.category2 == "Toys"
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: { "line-height": "1" },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _vm._v(
                                            "(price/case or tray with VAT)"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      disabled: !_vm.canUpdate,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.agreedPriceWithVatChange()
                                      },
                                    },
                                    model: {
                                      value: _vm.formData.agreedPriceWithVat,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "agreedPriceWithVat",
                                          $$v
                                        )
                                      },
                                      expression: "formData.agreedPriceWithVat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    label: "Per",
                                    prop: "agreedPriceWithVatUnit",
                                    rules: _vm.fpaRules1.agreedPriceWithVatUnit,
                                    "label-width": "80px",
                                    "label-position": "right",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: !_vm.canUpdate },
                                    model: {
                                      value:
                                        _vm.formData.agreedPriceWithVatUnit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "agreedPriceWithVatUnit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.agreedPriceWithVatUnit",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 9 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    prop: "agreedPriceWithoutVat",
                                    rules: _vm.fpaRules1.agreedPriceWithoutVat,
                                    "label-width": "230px",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("Agreed Price")]
                                  ),
                                  _vm.formData.category2 != "Toys"
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: { "line-height": "1" },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _vm._v(
                                            "(price/case or tray in RMB without VAT)"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.formData.category2 == "Toys"
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: { "line-height": "1" },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _vm._v(
                                            "(price/case or tray without VAT)"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      disabled: !_vm.canUpdate,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.agreedPriceWithoutVatChange()
                                      },
                                    },
                                    model: {
                                      value: _vm.formData.agreedPriceWithoutVat,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "agreedPriceWithoutVat",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.agreedPriceWithoutVat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    label: "Per",
                                    prop: "agreedPriceWithoutVatUnit",
                                    rules:
                                      _vm.fpaRules1.agreedPriceWithoutVatUnit,
                                    "label-width": "80px",
                                    "label-position": "right",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: !_vm.canUpdate },
                                    model: {
                                      value:
                                        _vm.formData.agreedPriceWithoutVatUnit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "agreedPriceWithoutVatUnit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.agreedPriceWithoutVatUnit",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _vm.formData.category2 == "planning-service"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    prop: "vat",
                                    rules: _vm.fpaRules1.vat,
                                    "label-width": "230px",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("VAT Rate")]
                                  ),
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      table: "TM_MATERIAL_RECORD",
                                      field: "URCHASE_TAX_RATE",
                                      disabled: !_vm.canUpdate,
                                    },
                                    on: { change: _vm.vatChange },
                                    model: {
                                      value: _vm.formData.vat,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "vat", $$v)
                                      },
                                      expression: "formData.vat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formData.category2 == "package-service" ||
                      _vm.formData.category2 == "toy-service" ||
                      _vm.formData.category2 == "planning-service" ||
                      _vm.formData.category2 == "Toys"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    prop: "estimateVolumeOfPurchase",
                                    rules:
                                      _vm.fpaRules1.estimateVolumeOfPurchase,
                                    "label-width": "230px",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("Estimate Volume of Purchase")]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: { "line-height": "1" },
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [_vm._v("(in unit of measurement)")]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      disabled: !_vm.canUpdate,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.estimateVolumeOfPurchaseInput()
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.formData.estimateVolumeOfPurchase,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "estimateVolumeOfPurchase",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.estimateVolumeOfPurchase",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "cost_analysis" },
            [
              _c(
                "div",
                {
                  staticClass: "info_box_title",
                  staticStyle: { "padding-top": "10px" },
                },
                [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "info_title" }, [
                    _vm._v("Cost Analysis"),
                  ]),
                ]
              ),
              _c(
                "el-row",
                { staticStyle: { width: "60.8%" }, attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "costImpactVsCurrentPrice" },
                        },
                        [
                          _c("p", { attrs: { slot: "label" }, slot: "label" }, [
                            _vm._v("Cost Impact Vs Current Price"),
                          ]),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "with unit price increased/decreased% and spending amount(K RMB) excluding VAT comparison",
                                placement: "top",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !_vm.canUpdate,
                                  title: _vm.formData.costImpactVsCurrentPrice,
                                },
                                model: {
                                  value: _vm.formData.costImpactVsCurrentPrice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "costImpactVsCurrentPrice",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.costImpactVsCurrentPrice",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "60.8%" }, attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            prop: "riskIdentifiHedgeJustifi",
                            rules: _vm.fpaRules1.riskIdentifiHedgeJustifi,
                          },
                        },
                        [
                          _c("p", { attrs: { slot: "label" }, slot: "label" }, [
                            _vm._v("Risk Identification & Hedge Justification"),
                          ]),
                          _c("el-input", {
                            attrs: {
                              disabled: !_vm.canUpdate,
                              type: "textarea",
                              rows: 5,
                              title: _vm.formData.riskIdentifiHedgeJustifi,
                            },
                            model: {
                              value: _vm.formData.riskIdentifiHedgeJustifi,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "riskIdentifiHedgeJustifi",
                                  $$v
                                )
                              },
                              expression: "formData.riskIdentifiHedgeJustifi",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("el-form", { ref: "formData2", attrs: { model: _vm.formData } }, [
        _c(
          "div",
          { staticClass: "tab_box" },
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "card" },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _vm.formData.category2 != "logistic" &&
                _vm.formData.category2 != "planning-service" &&
                _vm.formData.category2 != "package-service" &&
                _vm.formData.category2 != "toy-service"
                  ? _c(
                      "el-tab-pane",
                      { attrs: { label: "PQCP", name: "fpaPqcnTab" } },
                      [
                        _vm.canUpdate
                          ? _c(
                              "el-row",
                              { attrs: { type: "flex", justify: "start" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.downLoadTemplate },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.template")))]
                                ),
                                _c(
                                  "el-upload",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.updateFpaTemplate,
                                        expression: "updateFpaTemplate",
                                      },
                                    ],
                                    ref: "uploadTemplate",
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: {
                                      "show-file-list": false,
                                      headers: _vm.uploadHeader,
                                      action: _vm.templateUploadUrl,
                                      "on-success": () =>
                                        _vm.$message.success(
                                          _vm.$t("common.UploadSucceed")
                                        ),
                                      multiple: "false",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "primary" } },
                                      [_vm._v("模板更新")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-upload",
                                  {
                                    ref: "upload",
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: {
                                      "show-file-list": false,
                                      headers: _vm.uploadHeader,
                                      action: _vm.fileUploadUrl,
                                      "on-success": _vm.uploadSuccess,
                                      "on-error": _vm.uploadError,
                                      "before-upload": _vm.beforeAvatarUpload,
                                      multiple: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "primary" } },
                                      [_vm._v(_vm._s(_vm.$t("common.import")))]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.fpaPqcnAdd },
                                  },
                                  [_vm._v("Add")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger" },
                                    on: { click: _vm.fpaPqcnDel },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.tableVisible
                          ? _c(
                              "UTable",
                              {
                                ref: "fpaPqcnList",
                                staticClass: "PQCP",
                                staticStyle: { "margin-top": "10px" },
                                attrs: {
                                  data: _vm.formData.fpaPqcnList,
                                  "use-virtual": "",
                                  "big-data-checkbox": true,
                                  height: 500,
                                  border: "",
                                  "highlight-current-row": "",
                                  "max-height": "500",
                                  "header-cell-class-name":
                                    _vm.tableRowClassName,
                                  id: "table",
                                },
                                on: {
                                  "selection-change": _vm.handleFpaPqcnChange,
                                },
                              },
                              [
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    type: "selection",
                                    width: "55",
                                  },
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Supplier/Facility",
                                    width: "250px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.isNew == "N"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        staticClass:
                                                          "fpaPermanentDetail",
                                                        attrs: {
                                                          prop:
                                                            "fpaPqcnList." +
                                                            scope.$index +
                                                            ".plantId",
                                                          rules: {
                                                            required: true,
                                                            message:
                                                              "Can not be Empty!",
                                                            trigger: "change",
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "NOBR",
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                title:
                                                                  scope.row
                                                                    .facilityName,
                                                                disabled: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .facilityName,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "facilityName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.facilityName",
                                                              },
                                                            }),
                                                            _c("el-input", {
                                                              attrs: {
                                                                type: "hidden",
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .plantId,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "plantId",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.plantId",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            scope.row.isNew == "Y"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        staticClass:
                                                          "fpaPermanentDetail",
                                                        attrs: {
                                                          prop:
                                                            "fpaPqcnList." +
                                                            scope.$index +
                                                            ".plantId",
                                                          rules: {
                                                            required: true,
                                                            message:
                                                              "Please select!",
                                                            trigger: "change",
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                !_vm.canUpdate,
                                                              width: "250px",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .plantId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "plantId",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.plantId",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.fpaSupplierCoverageList,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: index,
                                                                  attrs: {
                                                                    label:
                                                                      item.plantName,
                                                                    value:
                                                                      item.plantId,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    69717338
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Supplied DC",
                                    "min-width": "400px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".suppliedDcArr",
                                                  rules: {
                                                    required: true,
                                                    message: "Please select!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "multiple_sel",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      multiple: "",
                                                      disabled:
                                                        !_vm.canUpdate ||
                                                        scope.row
                                                          .transportaionMethod ==
                                                          "SUPPLIER",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.getCurrentFreight(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.suppliedDcArr,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "suppliedDcArr",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.suppliedDcArr",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.suppliedDcList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label: item.dcName,
                                                          value:
                                                            item.tmDcId + "",
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1121117793
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Trade Term",
                                    width: "120px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".tradeTerm",
                                                  rules: {
                                                    required: true,
                                                    message: "Please select!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm.canUpdate,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.pqcpTradeTermChange(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.tradeTerm,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "tradeTerm",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.tradeTerm",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.priceTypeList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2069019602
                                  ),
                                }),
                                _vm.canUpdate
                                  ? _c("u-table-column", {
                                      attrs: {
                                        align: "center",
                                        prop: "newBoolean",
                                        width: "100",
                                        label: "New Item",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass:
                                                      "fpaPermanentDetail",
                                                    attrs: {
                                                      prop:
                                                        "fpaPqcnList." +
                                                        scope.$index +
                                                        ".newBoolean",
                                                    },
                                                  },
                                                  [
                                                    _c("el-checkbox", {
                                                      key: scope.row.isNew,
                                                      attrs: {
                                                        disabled:
                                                          !_vm.canUpdate,
                                                        checked:
                                                          scope.row.newBoolean,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.isNewChange(
                                                            scope.row,
                                                            scope.row.newBoolean
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.newBoolean,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "newBoolean",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.newBoolean",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        888060351
                                      ),
                                    })
                                  : _vm._e(),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "localItem",
                                    label: "Local Number",
                                    width: "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".localItem",
                                                },
                                              },
                                              [
                                                _c("MaterialInput", {
                                                  attrs: {
                                                    "can-pick":
                                                      scope.row.isNew == "N",
                                                    tmSupplierId:
                                                      _vm.chooseSuplierId,
                                                    disabled: true,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.inputLocalItem(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row.localItem,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "localItem",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.localItem",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4066192727
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "productDescription",
                                    label: "Product Description",
                                    width: "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".productDescription",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    title:
                                                      scope.row
                                                        .productDescription,
                                                    disabled:
                                                      scope.row.isNew == "N" ||
                                                      !_vm.canUpdate,
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .productDescription,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "productDescription",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.productDescription",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    116704609
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "packingSizePerUom",
                                    label: "Packing Size per SU",
                                    width: "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".packingSizePerUom",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    title:
                                                      scope.row
                                                        .packingSizePerUom,
                                                    disabled:
                                                      scope.row.isNew == "N" ||
                                                      !_vm.canUpdate,
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .packingSizePerUom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "packingSizePerUom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.packingSizePerUom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2894136480
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "uom",
                                    label: "Settlement Unit \n (per SU)",
                                    width: "120px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".uom",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        scope.row.isNew ==
                                                          "N" || !_vm.canUpdate,
                                                    },
                                                    model: {
                                                      value: scope.row.uom,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "uom",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.uom",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.uomList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    834178988
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "currentPricePerUom",
                                    label:
                                      "Current Price per SU \n(Exwork,excluding VAT)",
                                    width: "175px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".currentPricePerUom",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    title:
                                                      scope.row
                                                        .currentPricePerUom,
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .currentPricePerUom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "currentPricePerUom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.currentPricePerUom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    188744411
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "newPricePerUom",
                                    label: "New Price per SU \n(excluding VAT)",
                                    width: "130px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".newPricePerUom",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    onkeyup:
                                                      "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,6})?).*$/g, '$1')",
                                                    title:
                                                      scope.row.newPricePerUom,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.countPqcp(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.newPricePerUom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "newPricePerUom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.newPricePerUom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2879923222
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "currency",
                                    label: "Currency",
                                    width: "100px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".currency",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: { disabled: "" },
                                                    model: {
                                                      value: scope.row.currency,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "currency",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.currency",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.currencyList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label: item.value,
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3749148263
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "vat",
                                    label: "VAT",
                                    width: "90px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".vat",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm.canUpdate,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.countPqcp(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.vat,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "vat",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.vat",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.pqcnVatRateList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          value: item.code,
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3364413258
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportaionMethod",
                                    label: "Delivery Type",
                                    width: "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".transportaionMethod",
                                                  rules: {
                                                    required: true,
                                                    message: "Please select!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm.canUpdate,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.countPqcp(
                                                          scope.row
                                                        ),
                                                          _vm.getCurrentFreight(
                                                            scope.row
                                                          ),
                                                          _vm.delivertTypeChange(
                                                            scope.row
                                                              .transportaionMethod,
                                                            scope.row,
                                                            scope.$index
                                                          )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .transportaionMethod,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "transportaionMethod",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.transportaionMethod",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.newTransportaionMethodList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1560507729
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "currentFreight",
                                    label: "Current Freight",
                                    width: "150px",
                                  },
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "freight",
                                    label: "New Freight",
                                    width: "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.transportaionMethod !=
                                            "DC"
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass:
                                                      "fpaPermanentDetail",
                                                    attrs: {
                                                      prop:
                                                        "fpaPqcnList." +
                                                        scope.$index +
                                                        ".freight",
                                                      rules: {
                                                        required: true,
                                                        message:
                                                          "Can not be Empty!",
                                                        trigger: "change",
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      attrs: {
                                                        type: "number",
                                                        disabled:
                                                          !_vm.canUpdate,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          scope.row.freight =
                                                            _vm.utils.formatPositiveNumber(
                                                              scope.row.freight,
                                                              6
                                                            )
                                                        },
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.countPqcp(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.freight,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "freight",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.freight",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            scope.row.transportaionMethod ==
                                            "!DC"
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass:
                                                      "fpaPermanentDetail",
                                                    attrs: {
                                                      prop:
                                                        "fpaPqcnList." +
                                                        scope.$index +
                                                        ".freight",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      attrs: {
                                                        type: "number",
                                                        disabled: "",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          scope.row.freight =
                                                            _vm.utils.formatPositiveNumber(
                                                              scope.row.freight,
                                                              6
                                                            )
                                                        },
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.countPqcp(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.freight,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "freight",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.freight",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    543687362
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "ddpCost",
                                    label: "Total Cost \n(excluding VAT)",
                                    width: "120px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".ddpCost",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "number",
                                                    disabled: !_vm.canUpdate,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      scope.row.ddpCost =
                                                        _vm.utils.formatPositiveNumber(
                                                          scope.row
                                                            .volumeEstimation,
                                                          6
                                                        )
                                                    },
                                                    change: function ($event) {
                                                      return _vm.countPqcp(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row.ddpCost,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "ddpCost",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.ddpCost",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1114164506
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "change",
                                    label: "Change",
                                    width: "100px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".change",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: { width: "80%" },
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value: scope.row.change,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "change",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.change",
                                                  },
                                                }),
                                                _vm._v(" % "),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2160455190
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "validFrom",
                                    label: "Valid From(Date)",
                                    width: "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".validFrom",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    type: "date",
                                                    placeholder: "选择日期",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                  },
                                                  model: {
                                                    value: scope.row.validFrom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "validFrom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.validFrom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1686460586
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "validTo",
                                    label: "Valid To(Date)",
                                    width: "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".validTo",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    type: "date",
                                                    placeholder: "选择日期",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                  },
                                                  model: {
                                                    value: scope.row.validTo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "validTo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.validTo",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3213645066
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "volumeEstimation",
                                    label: "Volume Estimation",
                                    width: "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".volumeEstimation",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    type: "number",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.countPqcp(
                                                        scope.row
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      scope.row.volumeEstimation =
                                                        _vm.utils.formatPositiveNumber(
                                                          scope.row
                                                            .volumeEstimation,
                                                          2
                                                        )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .volumeEstimation,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "volumeEstimation",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.volumeEstimation",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1885931222
                                  ),
                                }),
                                _c("u-table-column", {
                                  staticClass: "Content Per SU",
                                  attrs: {
                                    align: "center",
                                    prop: "contentPerUom",
                                    label: "Content Per SU",
                                    width: "180px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".contentPerUom",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "number",
                                                    disabled: !_vm.canUpdate,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      scope.row.contentPerUom =
                                                        _vm.utils.formatPositiveNumber(
                                                          scope.row
                                                            .contentPerUom,
                                                          6
                                                        )
                                                    },
                                                    change: function ($event) {
                                                      return _vm.countPqcp(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.contentPerUom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "contentPerUom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.contentPerUom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    704047013
                                  ),
                                }),
                                _c("u-table-column", {
                                  staticClass: "Unit",
                                  attrs: {
                                    align: "center",
                                    prop: "unit",
                                    label: "Unit",
                                    width: "100px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".unit",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      disabled: !_vm.canUpdate,
                                                    },
                                                    model: {
                                                      value: scope.row.unit,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "unit",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.unit",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.pqcnUnitList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          value: item.code,
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1351017774
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "pricePerUnit",
                                    label: "Price per Unit",
                                    width: "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".pricePerUnit",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: "",
                                                    title:
                                                      scope.row.pricePerUnit,
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.pricePerUnit,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "pricePerUnit",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.pricePerUnit",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3823561347
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "remark",
                                    label: "Remark",
                                    width: "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaPqcnList." +
                                                    scope.$index +
                                                    ".remark",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    title: scope.row.remark,
                                                  },
                                                  model: {
                                                    value: scope.row.remark,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "remark",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.remark",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2694672017
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.formData.category2 == "logistic"
                  ? _c(
                      "el-tab-pane",
                      { attrs: { label: "PQCP", name: "fpaPcnTab" } },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "fpaLogisticRates",
                            staticClass: "campaign_table PQCP",
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              data: _vm.formData.fpaLogisticRates,
                              "max-height": "500",
                              border: "",
                              "highlight-current-row": "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                align: "center",
                                prop: "dcName",
                                label: "Supplied DC",
                                "min-width": "150px",
                              },
                            }),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  align: "center",
                                  label: "Transportation",
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationRate",
                                    label: "New Item Rate without VAT",
                                    "min-width": "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".transportationRate",
                                                  rules:
                                                    _vm.transportationRateRules(
                                                      scope.$index,
                                                      scope.row
                                                    ),
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.transportationRateChange(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .transportationRate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "transportationRate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.transportationRate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    783122034
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationRateWithVat",
                                    label: "New Item Rate with VAT",
                                    "show-overflow-tooltip": "",
                                    "min-width": "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".transportationRateWithVat",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("fix")(
                                                        scope.row
                                                          .transportationRateWithVat,
                                                        6
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2169851802
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationVat",
                                    label: "VAT Rate",
                                    "min-width": "160px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".transportationVat",
                                                  rules:
                                                    _vm.transportationVatRules(
                                                      scope.$index,
                                                      scope.row
                                                    ),
                                                },
                                              },
                                              [
                                                _c("ic-select", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    table: "TM_MATERIAL_RECORD",
                                                    field: "URCHASE_TAX_RATE",
                                                    disabled: !_vm.canUpdate,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.transportationVatChange(
                                                        scope.row,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .transportationVat,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "transportationVat",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.transportationVat",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2438709163
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationVatValue",
                                    label: "New Item VAT Value",
                                    "show-overflow-tooltip": "",
                                    "min-width": "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".transportationVatValue",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("fix")(
                                                        scope.row
                                                          .transportationVatValue,
                                                        6
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3363338970
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-table-column",
                              {
                                attrs: { align: "center", label: "Warehouse" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseRate",
                                    label: "New Item Rate without VAT",
                                    "min-width": "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".warehouseRate",
                                                  rules: _vm.warehouseRateRules(
                                                    scope.$index,
                                                    scope.row
                                                  ),
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.warehouseRateChange(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.warehouseRate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "warehouseRate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.warehouseRate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2366627890
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseRateWithVat",
                                    label: "New Item Rate with VAT",
                                    "show-overflow-tooltip": "",
                                    "min-width": "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".warehouseRateWithVat",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("fix")(
                                                        scope.row
                                                          .warehouseRateWithVat,
                                                        6
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4175620762
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseVat",
                                    label: "VAT Rate",
                                    "min-width": "160px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".warehouseVat",
                                                  rules: _vm.warehouseVatRules(
                                                    scope.$index,
                                                    scope.row
                                                  ),
                                                },
                                              },
                                              [
                                                _c("ic-select", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    table: "TM_MATERIAL_RECORD",
                                                    field: "URCHASE_TAX_RATE",
                                                    disabled: !_vm.canUpdate,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.warehouseVatChange(
                                                        scope.row,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.warehouseVat,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "warehouseVat",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.warehouseVat",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    196671499
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseVatValue",
                                    label: "New Item VAT Value",
                                    "show-overflow-tooltip": "",
                                    "min-width": "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "fpaLogisticRates." +
                                                    scope.$index +
                                                    ".warehouseVatValue",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("fix")(
                                                        scope.row
                                                          .warehouseVatValue,
                                                        6
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3324582490
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "adpCost",
                                label: "Total ADP Cost(without VAT)",
                                "show-overflow-tooltip": "",
                                "min-width": "200px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".warehouseRateWithVat",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row.adpCost,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                99492322
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "adpCostWithVat",
                                label: "Total ADP Cost(with VAT)",
                                "show-overflow-tooltip": "",
                                "min-width": "200px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".warehouseRateWithVat",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row.adpCostWithVat,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3251440419
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "currentAdpCost",
                                label: "Current ADP Cost(without VAT)",
                                "show-overflow-tooltip": "",
                                "min-width": "200px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".warehouseRateWithVat",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row.currentAdpCost,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                252402955
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "adpChange",
                                label: "Change",
                                "show-overflow-tooltip": "",
                                "min-width": "120px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".adpChange",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("percentSeparator")(
                                                    scope.row.adpChange
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1784600753
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "chargeUnit",
                                label: "Charge Unit",
                                "show-overflow-tooltip": "",
                                "min-width": "160px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".chargeUnit",
                                              rules: {
                                                required: true,
                                                message: "Please select!",
                                                trigger: "change",
                                              },
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TT_FPA_LOGISTIC_RATE",
                                                field: "CHARGE_UNIT",
                                                disabled: !_vm.canUpdate,
                                              },
                                              model: {
                                                value: scope.row.chargeUnit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "chargeUnit",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.chargeUnit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2035072479
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "estVolume",
                                label: "Volume Estimation",
                                "show-overflow-tooltip": "",
                                "min-width": "180px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".estVolume",
                                              rules: _vm.estVolumeRules(
                                                scope.$index,
                                                scope.row
                                              ),
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: !_vm.canUpdate,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.estVolumeChange(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.estVolume,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "estVolume",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.estVolume",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2175726770
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "totalEstimatedValue",
                                label: "Total Estimated Value(with VAT)",
                                "show-overflow-tooltip": "",
                                "min-width": "200px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".totalEstimatedValue",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f(
                                                    "thousandSeparatorAnd"
                                                  )(
                                                    scope.row
                                                      .totalEstimatedValue
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3545569695
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "remark",
                                label: "Remark",
                                "show-overflow-tooltip": "",
                                "min-width": "200px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaLogisticRates." +
                                                scope.$index +
                                                ".remark",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: !_vm.canUpdate,
                                              },
                                              model: {
                                                value: scope.row.remark,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "remark",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.remark",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4208801338
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.formData.category2 == "planning-service"
                  ? _c(
                      "el-tab-pane",
                      { attrs: { label: "PQCP", name: "fpaPcnTab" } },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "fpaDcSettles",
                            staticClass: "campaign_table PQCP",
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              data: _vm.formData.fpaDcSettles,
                              "max-height": "500",
                              border: "",
                              "highlight-current-row": "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                align: "center",
                                prop: "dcName",
                                label: "Supplied DC",
                                "min-width": "150px",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "settleDcId",
                                label: "Settle",
                                "min-width": "300px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaDcSettles." +
                                                scope.$index +
                                                ".settleDcId",
                                              rules: _vm.settleDcIdRules(
                                                scope.$index,
                                                scope.row
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  disabled: !_vm.canUpdate,
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.settleDcId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "settleDcId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.settleDcId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.settleDcOptions,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.tmDcId,
                                                    attrs: {
                                                      label: item.dcName,
                                                      value: item.tmDcId,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2050734843
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "vat",
                                label: "VAT Rate",
                                "min-width": "150px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "fpaPermanentDetail",
                                            attrs: {
                                              prop:
                                                "fpaDcSettles." +
                                                scope.$index +
                                                ".vat",
                                              rules: _vm.vatRules(
                                                scope.$index,
                                                scope.row
                                              ),
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TM_MATERIAL_RECORD",
                                                field: "URCHASE_TAX_RATE",
                                                disabled: !_vm.canUpdate,
                                              },
                                              model: {
                                                value: scope.row.vat,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "vat",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.vat",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1769406613
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.formData.category1 == 10
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: "Agreed Supply Quantity",
                          name: "agreedSupplyQty",
                        },
                      },
                      [
                        _vm.canUpdate
                          ? _c(
                              "el-row",
                              { attrs: { type: "flex", justify: "start" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: { type: "primary" },
                                    on: {
                                      click:
                                        _vm.downLoadAgreedSupplyQtyTemplate,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.template")))]
                                ),
                                _c(
                                  "el-upload",
                                  {
                                    ref: "upload",
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: {
                                      "show-file-list": false,
                                      headers: _vm.uploadHeader,
                                      action: _vm.agreedSupplyQtyFileUploadUrl,
                                      "on-success":
                                        _vm.agreedSupplyQtyUploadSuccess,
                                      "on-error": _vm.uploadError,
                                      "before-upload": _vm.beforeAvatarUpload,
                                      multiple: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "primary" } },
                                      [_vm._v(_vm._s(_vm.$t("common.import")))]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.fpaAgreedSupplyQtyAdd },
                                  },
                                  [_vm._v("Add")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger" },
                                    on: { click: _vm.fpaAgreedSupplyQtyDel },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.tableVisible
                          ? _c(
                              "UTable",
                              {
                                ref: "agreedSupplyList",
                                staticClass: "PQCP",
                                staticStyle: { "margin-top": "10px" },
                                attrs: {
                                  data: _vm.formData.agreedSupplyList,
                                  "use-virtual": "",
                                  "big-data-checkbox": true,
                                  height: 500,
                                  border: "",
                                  "highlight-current-row": "",
                                  "max-height": "500",
                                  id: "table2",
                                },
                                on: {
                                  "selection-change":
                                    _vm.handleFpaAgreedSupplyQtyChange,
                                },
                              },
                              [
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    type: "selection",
                                    width: "55",
                                  },
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Time Period From",
                                    "min-width": "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".periodFrom",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    type: "date",
                                                    placeholder: "选择日期",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                  },
                                                  model: {
                                                    value: scope.row.periodFrom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "periodFrom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.periodFrom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3245511250
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Time Period To",
                                    "min-width": "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".periodTo",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    type: "date",
                                                    placeholder: "选择日期",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                  },
                                                  model: {
                                                    value: scope.row.periodTo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "periodTo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.periodTo",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2209200242
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Local Number",
                                    "min-width": "180px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".localItem",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("MaterialInput", {
                                                  attrs: {
                                                    tmSupplierId:
                                                      _vm.chooseSuplierId,
                                                    disabled: true,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.agreedSupplyQtyInputLocalItem(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row.localItem,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "localItem",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.localItem",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1899995817
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Product Description",
                                    "min-width": "180px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".productDescription",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    title:
                                                      scope.row
                                                        .productDescription,
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .productDescription,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "productDescription",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.productDescription",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2061157754
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Plant/Facility",
                                    "min-width": "150px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".plantName",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    title: scope.row.plantName,
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value: scope.row.plantName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "plantName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.plantName",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1112235799
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "supplyQty",
                                    label: "Agreed Supply Quantity",
                                    "min-width": "180px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".supplyQty",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      "Can not be Empty!",
                                                    trigger: "change",
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.handleInput(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row.supplyQty,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "supplyQty",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.supplyQty",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1246843107
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Unit",
                                    "min-width": "100px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".unit",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: { disabled: "" },
                                                  model: {
                                                    value: scope.row.unit,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "unit",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.unit",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3803694305
                                  ),
                                }),
                                _c("u-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: "Remarks",
                                    "min-width": "200px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "fpaPermanentDetail",
                                                attrs: {
                                                  prop:
                                                    "agreedSupplyList." +
                                                    scope.$index +
                                                    ".remarks",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: !_vm.canUpdate,
                                                    title: scope.row.remarks,
                                                  },
                                                  model: {
                                                    value: scope.row.remarks,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "remarks",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.remarks",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1209969914
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "Attachment", name: "attachment" } },
                  [
                    _c("table", { staticClass: "table-d" }, [
                      _c("tr", [
                        _c("td", { staticClass: "title" }, [_vm._v("Type")]),
                        _c("td", { staticClass: "title" }, [
                          _vm._v("Attachment"),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("System Document")]),
                        _c(
                          "td",
                          [
                            _vm.isPdfDownload
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: { type: "warning" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDownload("System Document")
                                      },
                                    },
                                  },
                                  [_vm._v("Download by PDF")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Signoff Document")]),
                        _c("td", [
                          _vm.canSignatureDownload
                            ? _c(
                                "div",
                                _vm._l(_vm.files1, function (item, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "warning" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDownload(
                                                "Signoff Document",
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.documentName))]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("Other Document")]),
                        _c("td", [
                          _vm.canAttachmentDownload
                            ? _c(
                                "div",
                                _vm._l(_vm.files2, function (item, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "warning" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDownload(
                                                "Other Document",
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.documentName))]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm.ttFpaId > 0
                  ? _c(
                      "el-tab-pane",
                      { attrs: { label: "Audit Record", name: "fpaLog" } },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "table",
                            attrs: {
                              data: _vm.formData.auditLogList,
                              border: "",
                              "highlight-current-row": "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "operatorName",
                                align: "center",
                                label: "Update by",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "createDate",
                                label: "Update Time",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateFormatFilter")(
                                                scope.row.createDate,
                                                "YYYY-MM-DD"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3592427407
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "action",
                                align: "center",
                                label: "Update Log",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "comments",
                                align: "center",
                                label: "Suggestion",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                sortable: "",
                                prop: "docs",
                                align: "center",
                                label: "Attachment",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateFormatFilter")(
                                              scope.row.effectiveBeginDate,
                                              "YYYY-MM-DD HH:mm"
                                            )
                                          ) + " "
                                        ),
                                        _c("fileList", {
                                          attrs: { files: scope.row.docs },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2113543
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c("SelDcPlant", {
            ref: "supplierSelRef",
            attrs: { multipleSelectionFlag: true, params: _vm.params },
            on: { subCallMethod: _vm.selectDcPlantMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showFileUpload,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFileUpload = $event
            },
          },
        },
        [
          _c("FileUpload", {
            ref: "fileUploadRef",
            attrs: {
              recType: _vm.bizType,
              attachmentAccept: _vm.attachmentAccept,
              "max-length": _vm.fileListMaxLength,
              bizId: _vm.ttFpaId,
              seq: _vm.fileSeq,
              attachmentName: _vm.bizNo,
              showFileList: true,
              disabled: _vm.fileUploadDisabled,
            },
            on: { onSuccessUpload: _vm.onSuccessUpload },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            visible: _vm.showAuditPage,
            "append-to-body": "",
            width: "25%",
            title: _vm.dialogTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAuditPage = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "formData", attrs: { model: _vm.formData } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20, offset: 2 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class:
                            _vm.dialogTitle == "Reject" ? "is-required" : "",
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("fpaManage.permanent.auditRemark"),
                            prop: "auditRemark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.formData.auditRemark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "auditRemark", $$v)
                              },
                              expression: "formData.auditRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fpaApproveConfirm },
                    },
                    [_vm._v("Confirm")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showAuditPage = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCategoryLeaderPage,
            "append-to-body": "",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCategoryLeaderPage = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticStyle: { "margin-top": "10px" },
              attrs: { model: _vm.formData, "label-width": "150px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.submitTitle } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.formData.ttCategoryLeaderId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "ttCategoryLeaderId",
                                    $$v
                                  )
                                },
                                expression: "formData.ttCategoryLeaderId",
                              },
                            },
                            _vm._l(
                              _vm.ssCategoryLeaderList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.userName,
                                    value: item.tmUserId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-row", [
                _c(
                  "div",
                  { attrs: { align: "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.ssCategoryLeaderConfirm },
                      },
                      [_vm._v("Confirm")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.showCategoryLeaderPage = false
                          },
                        },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            visible: _vm.showRejectPage,
            "append-to-body": "",
            width: "25%",
            title: "Reject",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRejectPage = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "formData", attrs: { model: _vm.formData } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20, offset: 2 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "is-required",
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("fpaManage.permanent.auditRemark"),
                            prop: "auditRemark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.formData.auditRemark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "auditRemark", $$v)
                              },
                              expression: "formData.auditRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { align: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.returnToSuConfirm("confirm")
                        },
                      },
                    },
                    [_vm._v("Confirm")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showRejectPage = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }